<template>
  <div class="d-flex align-items-start" >
    <LeftMenu @show="show" showTA showCarrierTable showClientTable/>
    <div v-if="whatShow === '3'" class="tab-pane active" id="left-user" role="tabpanel" aria-labelledby="left-user-tab">
      <TransportAccounting role="user"/>
    </div>
    <div v-if="whatShow === '4'" class="tab-pane active" id="left-user" role="tabpanel" aria-labelledby="left-user-tab">
      <AtiCarrier/>
    </div>
  </div>
</template>

<script setup>
import LeftMenu from '@/components/LeftMenu.vue'
import TransportAccounting from '@/components/tables/TransportAccounting.vue'
import { ref } from "vue";
import AtiCarrier from "@/components/tables/AtiCarrier.vue";


const whatShow = ref('3')
function show(n) {
  whatShow.value = n;
}

</script>

<style scoped>

</style>
